export function createLabelHandler(elements, activeClass = 'is-float') {
  elements.forEach((control) => {
    if (control.tagName.toUpperCase() === 'BUTTON') {
      return false
    }
    const controlContainer = control.closest('.sea-form-control')
    if (!controlContainer) {
      return false
    }
    const label = controlContainer.querySelector('label')
    const handler = () => {
      label.classList.toggle(activeClass, control.value !== '')
    }
    if (controlContainer) {
      control.addEventListener('focus', () => {
        label.classList.add(activeClass)
      })

      control.addEventListener('blur', handler)

      handler()
    } else {
      console.warn('Not found .sea-form-control parent of control', control)
    }
  })
}
